<template>
  <v-card class="seccion-card" data-test="pet-health">
    <v-card-title class="section-head">
      <v-icon small>mdi-needle</v-icon>Vacunas y desparasitación
    </v-card-title>

    <SourceError360 v-if="error" label="las vacunas y desparasitaciones" @retry="$emit('retry')" />
    <v-skeleton-loader v-else-if="loading" type="table-row@3" data-test="pet-health-loading" />
    <p v-else-if="!health" class="empty-state" data-test="pet-health-empty">
      Sin información de vacunas ni desparasitaciones.
    </p>
    <div v-else class="health-groups">
      <section v-for="group in groups" :key="group.key" class="health-group" :data-test="`pet-health-${group.key}`">
        <h4 class="group-title">
          {{ group.title }}
          <v-chip
            v-if="group.overdue"
            x-small
            outlined
            color="error"
            class="ml-2 font-weight-bold"
            :data-test="`pet-health-${group.key}-overdue`"
          >Atrasada</v-chip>
        </h4>
        <table class="health-table">
          <thead>
            <tr>
              <th>Ítem</th>
              <th>Estado</th>
              <th>Última dosis</th>
              <th>Próxima dosis</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in group.items" :key="item.key" :data-test="`pet-health-item-${item.key}`">
              <td>{{ item.label }}</td>
              <td>
                <v-chip x-small outlined :color="display(item.status).color" class="font-weight-bold">
                  <v-icon left x-small>{{ display(item.status).icon }}</v-icon>{{ display(item.status).text }}
                </v-chip>
              </td>
              <td>{{ formatHealthDate(item.lastDose) }}</td>
              <td>{{ formatHealthDate(item.nextDose) }}</td>
            </tr>
          </tbody>
        </table>
      </section>
      <p class="health-note">
        Calculado como en el carnet de salud de la app: desde la última dosis registrada y el
        recordatorio de próxima dosis (o el intervalo por defecto si no hay uno).
      </p>
    </div>
  </v-card>
</template>

<script>
import SourceError360 from './SourceError360.vue';
import { healthStatusDisplay, formatHealthDate } from '@/utils/pet-health.utils';

// Tarjeta «Vacunas y desparasitación» de una mascota en la 360: estado de cada vacuna y tipo de
// desparasitación según GET /pets/360/health-status.
export default {
  name: 'PetHealth360Card',
  components: { SourceError360 },
  props: {
    // Estado de la mascota (un elemento de `pets` de la respuesta); null si no viene.
    health: { type: Object, default: null },
    loading: { type: Boolean, default: false },
    error: { type: Boolean, default: false }
  },
  emits: ['retry'],
  computed: {
    groups() {
      return [
        { key: 'vaccines', title: 'Vacunas', items: this.health.vaccines, overdue: this.health.hasOverdueVaccines },
        {
          key: 'deworming',
          title: 'Desparasitación',
          items: this.health.deworming,
          overdue: this.health.hasOverdueDeworming
        }
      ];
    }
  },
  methods: {
    display: healthStatusDisplay,
    formatHealthDate
  }
};
</script>

<style scoped>
.seccion-card {
  margin-bottom: 20px;
}
.section-head {
  font-size: 0.9375rem;
  font-weight: 600;
  padding: 15px 20px;
  border-bottom: 1px solid var(--pw-divider);
}
.section-head .v-icon {
  margin-right: 8px;
  color: var(--pw-text-muted);
}
.empty-state {
  margin: 0;
  padding: 16px 20px;
  color: var(--pw-text-muted);
}
.health-groups {
  padding: 8px 20px 16px;
}
.health-group + .health-group {
  margin-top: 16px;
}
.group-title {
  display: flex;
  align-items: center;
  font-size: 0.8125rem;
  font-weight: 600;
  margin: 8px 0;
}
.health-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8125rem;
}
.health-table th {
  text-align: left;
  font-weight: 600;
  color: var(--pw-text-faint);
  padding: 6px 8px;
  border-bottom: 1px solid var(--pw-divider);
}
.health-table td {
  padding: 6px 8px;
  border-bottom: 1px solid var(--pw-divider);
}
.health-note {
  margin: 12px 0 0;
  font-size: 0.75rem;
  color: var(--pw-text-faint);
}
</style>
